import { ConstraintsService } from "shared/services/ConstraintsService";
import { create } from "./store";

type ConstraintsProductStoreState = {
  products: any;
  microcategories: any;

  //** search products and microcategories */
  productsSearchResults: any[];
  microcategoriesSearchResults: any[];
  //** end search products and microcategories */
};

type ConstraintsProductStoreActions = {
  setProducts: (products: any) => void;
  setMicrocategories: (microcategories: any) => void;

  //** search products and microcategories */
  fetchSearchProducts: (productSearchString: string) => Promise<void>;
  resetProductsSearchResults: () => void;
  fetchSearchMicrocategories: (
    microCategorySearchString: string,
  ) => Promise<void>;
  resetMicrocategoriesSearchResults: () => void;
  //**  */

  resetStore: () => void;
};

const initialData: ConstraintsProductStoreState = {
  products: null,
  microcategories: null,

  //** search products and microcategories */
  productsSearchResults: [],
  microcategoriesSearchResults: [],
  //** */
};

const constraintsProductMicrocatsStore = create<
  ConstraintsProductStoreState & ConstraintsProductStoreActions
>()((set, get) => ({
  ...initialData,
  setProducts: (products) => {
    set({ products: products });
  },
  setMicrocategories: (microcategories) => {
    set({ microcategories: microcategories });
  },

  //** search products and microcategories */
  fetchSearchMicrocategories: async (microCategorySearchString: string) => {
    if (microCategorySearchString.length > 0) {
      const results = await ConstraintsService.searchMicroCategories(
        microCategorySearchString,
      );
      set({ microcategoriesSearchResults: results });
    } else {
      set({ microcategoriesSearchResults: [] });
    }
  },
  fetchSearchProducts: async (productSearchString: string) => {
    if (productSearchString.length > 0) {
      const results: any[] =
        await ConstraintsService.searchProducts(productSearchString);
      set({ productsSearchResults: results });
    } else {
      set({ productsSearchResults: [] });
    }
  },
  resetProductsSearchResults: () => {
    set({ productsSearchResults: [] });
  },
  resetMicrocategoriesSearchResults: () => {
    set({ microcategoriesSearchResults: [] });
  },
  //**  */

  resetStore: () => {
    set(initialData);
  },
}));

export default constraintsProductMicrocatsStore;
